import React from 'react';
import { colors } from '../constants';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const informationIconSvg = (props) => {
  const { size, color, verticalAlign, hoverColor, marginLeft, ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      height={size}
      width={size}
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M10,19 C5.02943725,19 1,14.9705627 1,10
        C1,5.02943725 5.02943725,1 10,1 C14.9705627,1 19,5.02943725 19,10 C19,14.9705627
        14.9705627,19 10,19 Z M10,17.5 C14.1421356,17.5 17.5,14.1421356 17.5,10 C17.5,5.85786438
        14.1421356,2.5 10,2.5 C5.85786438,2.5 2.5,5.85786438 2.5,10 C2.5,14.1421356 5.85786438,17.5
        10,17.5 Z M10.2347973,13.177992 C9.72457326,13.6208051 9.26355797,13.8422857
        8.85135135,13.8422857 C8.56756757,13.8422857 8.36153094,13.7615453 8.23310811,13.6002126
        C8.10468528,13.4388799 8.04054054,13.2568065 8.04054054,13.0541407 C8.04054054,12.9265856
        8.05734353,12.8083639 8.09121622,12.6994754 C8.12495555,12.5907351 8.16216216,12.4799207
        8.2027027,12.3673286 L9.16554054,10.1492632 C9.21955014,10.0217081 9.2584904,9.91844929
        9.28209459,9.83963479 C9.30569879,9.76082028 9.31756757,9.69148722 9.31756757,9.63133931
        C9.31756757,9.57133955 9.30743243,9.5282286 9.28716216,9.50185834 C9.26689189,9.47563622
        9.23982041,9.46245109 9.20608108,9.46245109 C9.11819879,9.46245109 8.94763514,9.6107468
        8.69425676,9.90719008 C8.44087838,10.2036334 8.29045164,10.3519291 8.24324324,10.3519291
        C8.18923364,10.3519291 8.13509068,10.3105959 8.08108108,10.2280777 C8.02693812,10.1455595
        8,10.0929671 8,10.0704487 C8,9.99533788 8.06414474,9.87341243 8.19256757,9.70452421
        C8.32085704,9.53563598 8.48315256,9.35741446 8.67905405,9.1697115 C8.85468528,8.99711958
        9.06578947,8.83578688 9.3125,8.68556525 C9.55907717,8.53549177 9.77698257,8.46038095
        9.96621622,8.46038095 C10.2702703,8.46038095 10.4983108,8.55608428 10.6503378,8.74749093
        C10.8023649,8.93889759 10.8783784,9.1697115 10.8783784,9.43993266 C10.8783784,9.55252481
        10.8682432,9.67267248 10.847973,9.80022754 C10.8277027,9.92778259 10.7838282,10.0591895
        10.7162162,10.1943001 L9.94594595,12.0747371 C9.88513514,12.2323661 9.84112731,12.3599212
        9.81418919,12.4575504 C9.78711771,12.5551797 9.77364865,12.622735 9.77364865,12.6602163
        C9.77364865,12.7052531 9.78378378,12.7334012 9.80405405,12.7446604 C9.82432432,12.7559196
        9.84459459,12.7615492 9.86486486,12.7615492 C10.0134246,12.7615492 10.1874555,12.6433275
        10.3868243,12.406884 C10.5861931,12.1704404 10.7127489,12.0522187 10.7668919,12.0522187
        C10.8141003,12.0522187 10.864776,12.0916259 10.9189189,12.1704404 C10.9729285,12.2492549
        11,12.3036251 11,12.3336991 C11,12.4538467 10.744888,12.7353271 10.2347973,13.177992 Z
        M11.5805176,7.24514914 C11.3716108,7.44781162 11.1174383,7.54914286 10.818,7.54914286
        C10.5263394,7.54914286 10.274189,7.44781162 10.0613934,7.24514914 C9.8485978,7.04248666
        9.7422,6.80234347 9.7422,6.52457143 C9.7422,6.24679939 9.8485978,6.0066562
        10.0613934,5.80399372 C10.274189,5.60133124 10.5263394,5.5 10.818,5.5 C11.1174383,5.5
        11.3716108,5.60133124 11.5805176,5.80399372 C11.7892688,6.0066562 11.8938,6.24679939
        11.8938,6.52457143 C11.8938,6.80234347 11.7894244,7.04233851 11.5805176,7.24514914 Z"
      />
    </svg>
  );
};

const InformationIcon = styled(informationIconSvg)`
  vertical-align: ${(props) => props.verticalAlign};
  margin-left: ${(props) => props.marginLeft};

  &:hover {
    path {
      fill: ${(props) => props.hoverColor};
    }
  }
`;

InformationIcon.displayName = 'InformationIcon';

InformationIcon.propTypes = {
  verticalAlign: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  size: PropTypes.string,
  marginLeft: PropTypes.string,
};

InformationIcon.defaultProps = {
  verticalAlign: 'middle',
  color: colors.mediumGrey,
  hoverColor: colors.lightGrey,
  size: '20px',
  marginLeft: '5px',
};

export default InformationIcon;
